import React, { useState } from 'react';
import cx from 'classnames';

import { MDText } from 'i18n-react';

import { ArrowRightIcon } from '@motorway/mw-highway-code';
import { InfoBox } from '@motorway/mw-highway-code/alpha';
import { INFOBOX_VARIANT, SIZE } from '@motorway/mw-highway-code/enums';

import { Modal } from 'Storybook/components/local/Modal/Modal';

import { IncodeAuthorisationLink } from '../uploadDocuments/pages/IncodeSDKPage/components/IncodeAuthorisationLink/IncodeAuthorisationLink';
import { INCODE_SESSION_VERIFICATION_STATUS } from '../uploadDocuments/pages/IncodeSDKPage/hooks/useIncodeVerificationDocuments.constants';
import { IncodeSessionVerificationStatus } from '../uploadDocuments/pages/IncodeSDKPage/hooks/useIncodeVerificationDocuments.types';
import { INCODE_ANALYTICS } from '../uploadDocuments/pages/IncodeSDKPage/IncodeAnalytics';

import LocalTexts from './KeeperVerificationBadge.json';

import styles from './KeeperVerificationBadge.module.scss';

const LocalT = new MDText(LocalTexts);

export const KeeperVerificationBadge = ({
  keeperName = null,
  keeperVerificationStatus,
  saleVerificationId,
}: {
  keeperName?: string | null;
  keeperVerificationStatus: IncodeSessionVerificationStatus;
  saleVerificationId: string;
}) => {
  const [showModal, setShowModal] = useState(false);
  const isInteractive = keeperVerificationStatus === INCODE_SESSION_VERIFICATION_STATUS.PENDING;

  const handleToggleModal = (state: boolean) => {
    setShowModal(state);
    if (state) {
      INCODE_ANALYTICS.INCODE_AUTHORISATION_LINK_MODAL_OPENED();
    }
  };

  const Tag = (isInteractive ? 'button' : 'div') as React.ElementType;
  const textKey = { completed: 'completed', failed: 'failed', pending: 'pending' }[keeperVerificationStatus] ?? 'pending';
  const badgeText = (textKey === 'pending' && keeperName)
    ? LocalT.translate('pendingWithName', { keeperName })
    : LocalT.translate(textKey);
  const tagProps = isInteractive
    ? { onClick: () => handleToggleModal(true), role: 'button', type: 'button' as const }
    : {};

  return (
    <>
      <Tag className={styles.component} {...tagProps}>
        <span className={cx(styles.indicator, styles[keeperVerificationStatus])} />
        {badgeText}
        {isInteractive && <ArrowRightIcon />}
      </Tag>

      {showModal && (
        <Modal
          shouldCloseOnEsc
          shouldCloseOnOverlayClick
          withCloseButton
          dismissModal={() => setShowModal(false)}
          size={SIZE.SMALL}
        >
          <IncodeAuthorisationLink
            headingElement="h1"
            keeperName={keeperName}
            saleVerificationId={saleVerificationId}
          />
          <div className={styles.modalAttention}>
            <InfoBox
              content={LocalT.translate('modalAttention.content')}
              variant={INFOBOX_VARIANT.INFO}
            />
          </div>
        </Modal>
      )}
    </>
  );
};
